import { GET_DRIVER_REQUESTED, GET_ADDDRIVER_REQUESTED, GET_UPDATEDRIVER_REQUESTED, GET_MATRIXDRIVER_REQUESTED, GET_TICKETDRIVER_REQUESTED, GET_MOREDRIVER_REQUESTED } from "resources/actionTypes";

export function getDriver(data) {
  return {
    type: GET_DRIVER_REQUESTED,
    payload: data,
  };
}

export function postAddDriver(userAddDriver) {
  const data = {
    userAddDriver: userAddDriver,
  }
  return {
    type: GET_ADDDRIVER_REQUESTED,
    payload: data,
  };
}

export function patchUpdateDriver(userUpdateDriver) {
  const data = {
    userUpdateDriver: userUpdateDriver,
  }
  return {
    type: GET_UPDATEDRIVER_REQUESTED,
    payload: data,
  };
}

export function getMatrixDriver(data) {
  return {
    type: GET_MATRIXDRIVER_REQUESTED,
    payload: data,
  };
}

export function getTicketDriver(data) {
  return {
    type: GET_TICKETDRIVER_REQUESTED,
    payload: data,
  };
}

export function getMoreDriver(data) {
  return {
    type: GET_MOREDRIVER_REQUESTED,
    payload: data,
  };
}